import React, { useState } from "react";
import ExtractCard from "./ExtractCard";
import EmptyExtract from "./EmptyExtract";
import Flex from "../elements/Flex";
import IcArrowBack from "../icons/IcArrowBack";
import IcArrowFoward from "../icons/IcArrowFoward";

const ITEMS_PER_PAGE = 10;

const ExtractList = ({ filteredExtractList, selectedTab, schedules, currentPage, setCurrentPage }) => {


  const isScheduleTab = selectedTab === "schudule";

  const extractData = isScheduleTab ? schedules && schedules.rows || [] : filteredExtractList || [];

  const totalPages = Math.ceil(extractData.length / ITEMS_PER_PAGE);

  const paginatedData = extractData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleNext = () => {
    setCurrentPage(prev => Math.min(prev + 1, totalPages));
  };

  const handlePrev = () => {
    setCurrentPage(prev => Math.max(prev - 1, 1));
  };

  const validateEmptySchedule = () => {
    if (isScheduleTab) {
      return schedules && schedules.rows.every(item => item.processAt);
    }
    return false;
  };

  return (
    <div>
      <Flex
        flex={1}
        flexDirection="column"
        width="100%"
        border="1px dashed"
        borderRadius="xs"
        borderColor={{ default: "transparent", sm: "text.lightest" }}
        gap="24px"
        mt={2}
        p={{ default: "none", sm: 3 }}
      >
        {paginatedData.map((item, index) => {
          if (isScheduleTab) {
            if (item.processAt) return null;

            return (
              <ExtractCard
                key={item.id}
                type="F"
                balance={Number(item.amount)}
                date={item.scheduleDate}
              />
            );
          }

          return (
            <ExtractCard
              key={index}
              type={item.type}
              balance={item.amount}
              date={item.creditDate}
              extract={item}
            />
          );
        })}

        { (extractData.length === 0 || validateEmptySchedule()) && <EmptyExtract />}
      </Flex>

      {(totalPages > 1 && !validateEmptySchedule()) && (
        <Flex justifyContent="center" mt={3} gap={2}>
          <IcArrowBack style={{ color: '#BE00FF', opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'default' : 'pointer'}} onClick={currentPage === 1 ? null : handlePrev} disabled={currentPage === 1}/>
          <span style={{ userSelect: 'none' }}>Página {currentPage} de {totalPages}</span>
          <IcArrowFoward style={{ color: '#BE00FF', opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'default' : 'pointer'}} onClick={currentPage === totalPages ? null : handleNext} disabled={currentPage === totalPages}/>
        </Flex>
      )}
    </div>
  );
};

export default ExtractList;